/**
 * ListSkeleton — Skeleton de lista simples
 */
import { SkeletonBar } from './SkeletonBar';
import { T } from '../../styles/tokens';

interface ListSkeletonProps {
  rows?: number;
}

const WIDTHS = ['80%', '65%', '90%', '55%', '75%'];

export function ListSkeleton({ rows = 5 }: ListSkeletonProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: T.space3 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonBar key={i} width={WIDTHS[i % WIDTHS.length]} height={14} />
      ))}
    </div>
  );
}
